<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item label="模糊搜索">
                        <!-- <el-select v-model="lb_value" placeholder="请选择" size="small" filterable clearable>
                            <el-option v-for="item in  lb_options" :key="item.id" :label="item.name_2" :value="item.id">
                            </el-option>
                        </el-select> -->
                        <el-cascader v-model="lb_value" size="small" :props="lb_props" :options="lb_options">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
                </div>

            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                <el-table-column prop="id" label="编号"></el-table-column>
                <el-table-column prop="name" label="音频标题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="音频封面">
                    <template slot-scope="scope">
                        <div class="u-f u-wrap">
                            <div v-for="(item,index) in scope.row.cover_map" :key="index" @click="goprev(item)">
                                <img :src="item.url" alt="" width="50">
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序"></el-table-column>
                <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="130" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row,scope.$index)"></el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="handleDelet(scope.row,scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <el-dialog title="音频展示设置" :visible.sync="dialogVisible" center top="20px" width="70%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <el-form-item label="人员" prop='ry_value'>
                        <el-select v-model="ruleForm.ry_value" clearable placeholder="请选择" size="small" filterable>
                            <el-option v-for="item in  ry_options" :key="item.id" :label="item.nickname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="音频类别" prop='lb_value'>
                        <!-- <el-select v-model="ruleForm.lb_value" placeholder="请选择" size="small" filterable>
                            <el-option v-for="item in  lb_options" :key="item.id" :label="item.name_2" :value="item.id">
                            </el-option>
                        </el-select> -->
                        <el-cascader v-model="ruleForm.lb_value" size="small" :props="lb_props" :options="lb_options">
                        </el-cascader>
                    </el-form-item>
                    <el-form-item label="音频名称" prop='lb_title'>
                        <el-input v-model="ruleForm.lb_title" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="关键词">
                        <div class="u-f u-ac">
                            <el-input v-model="ruleForm.keyword" size="small" placeholder="用顿号分割(、)"></el-input>
                            <el-tag type="success">用顿号分割(、)</el-tag>
                        </div>
                    </el-form-item>
                    <el-form-item label="音频封面" required>
                        <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                            :headers="{ token:$store.state.user.token }" :data="{ image_class_id:'72' ,file_type:'1'}"
                            :file-list="ruleForm.lb_mapList" :on-success="uploadSuccess" :limit='1'
                            list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="音频上传" required>
                        <el-upload action="/admin/uploadFile" name="img" ref="uploads"
                            :headers="{ token:$store.state.user.token }" :data="{ image_class_id:'72',file_type:'3' }"
                            :file-list="ruleForm.lb_fileList" :on-success="uploadSuccessed" :limit='1'
                            :on-preview="uploadPrev">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="音频详情">
                        <tinymce ref="editor" v-model="ruleForm.lb_content"
                            toolbar="undo redo |  formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists table | removeformat | imageUpload" />
                    </el-form-item>
                    <el-form-item label="免责声明">
                        <el-select v-model="ruleForm.lb_state" placeholder="请选择" size="small">
                            <el-option v-for="item in state_options" :key="item.id" :label="item.content_name"
                                :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="排序" prop='lb_sort'>
                        <el-input v-model="ruleForm.lb_sort" size="small" type="number"> </el-input>
                    </el-form-item>
                    <div class="u-f u-ac">
                        <el-form-item label="基础点赞">
                            <el-input v-model="ruleForm.lb_dz" size="small" type="number"> </el-input>
                        </el-form-item>
                        <el-form-item label="基础浏览">
                            <el-input v-model="ruleForm.lb_ll" size="small" type="number"> </el-input>
                        </el-form-item>
                        <el-form-item label="基础收藏">
                            <el-input v-model="ruleForm.lb_sc" size="small" type="number"> </el-input>
                        </el-form-item>
                    </div>
                    <el-form-item label="发布设置" prop='lb_put'>
                        <el-radio-group v-model="ruleForm.lb_put">
                            <el-radio label="1" style="width:100%;margin-bottom:0px">立即发布</el-radio>
                            <div>
                                <el-radio label="2">定时发布</el-radio>
                                <el-date-picker v-model="ruleForm.lb_dstime" :clearable="false"
                                    :disabled="ruleForm.lb_put==2?false:true" size="mini" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间" default-time="12:00:00">
                                </el-date-picker>
                            </div>
                            <el-radio label="3" style="width:100%">暂不发布</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>

        <!--  -->
        <el-dialog :visible.sync="dialog_prev" width="60vw" top="5vh">
            <div style="margin: -60px -20px -30px -20px;">
                <img :src="urls" class="w-100" />
            </div>
        </el-dialog>


    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import tinymce from '@/components/common/tinymce.vue';
    export default {
        components: {
            tinymce
        },
        data() {
            return {
                lb_value: '',
                lb_options: [],
                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 15,
                height: null,
                // 
                eid: '0',
                dialogVisible: false,
                subloading: false,

                ruleForm: {
                    lb_title: '',
                    lb_value: '',
                    lb_content: '',
                    lb_sort: 50,
                    lb_put: '1',
                    lb_dstime: '',
                    lb_mapList: [],
                    lb_fileList: [],
                    keyword: '',
                    lb_state: '',
                    ry_value: '',
                    lb_dz: '',
                    lb_ll: '',
                    lb_sc: '',
                },
                ry_options: [],
                mapListed: [],
                fileListed: [],
                state_options: [],
                rule: {
                    lb_value: [{
                        required: true,
                        message: '请填写音频类别',
                        trigger: 'blur'
                    }],
                    lb_title: [{
                        required: true,
                        message: '请填写音频名称',
                        trigger: 'blur'
                    }],
                    lb_sort: [{
                        required: true,
                        message: '请填写排序',
                        trigger: 'blur'
                    }],
                    lb_put: [{
                        required: true,
                        message: '请选择发布设置',
                        trigger: 'blur'
                    }],
                },
                lb_props: {
                    label: "name",
                    value: "id",
                    children: 'child'
                },
                // 
                dialog_prev: false,
                urls: '',
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.getlbxx()
            that.getstate()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 200 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios.post("/admin/health/list", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        health_category_id: that.lb_value,
                        type: '3'
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.totalCount
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.eid = '0'
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm.lb_title = ''
                that.ruleForm.lb_value = ''
                that.ruleForm.lb_content = ''
                that.ruleForm.lb_put = '1'
                that.ruleForm.lb_dstime = ''
                that.ruleForm.lb_mapList = []
                that.ruleForm.lb_sort = 50
                that.mapListed = []
                that.ruleForm.lb_fileList = []
                that.fileListed = []
                that.ruleForm.lb_state = ''
                that.ruleForm.keyword = ''
                that.ruleForm.ry_value = ''
                that.ruleForm.lb_dz = ''
                that.ruleForm.lb_ll = ''
                that.ruleForm.lb_sc = ''
            },
            // 获取人员
            getper() {
                let that = this
                axios
                    .post(`/admin/doctorAssistantList`, {}, {
                        token: true
                    })
                    .then(response => {
                        that.ry_options = response.data.data
                    })
                    .catch(error => {})
            },
            submit(formName) {
                let that = this
                var time;
                if (that.ruleForm.lb_put == '1') {
                    time = that.gettimes()
                } else if (that.ruleForm.lb_put == '2') {
                    time = that.ruleForm.lb_dstime
                } else {
                    time = that.ruleForm.lb_put
                }
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (that.mapListed.length < 1) return that.$message.error('请上传音频封面');
                        if (that.fileListed.length < 1) return that.$message.error('请上传音频');
                        that.subloading = true
                        let urls;
                        if (this.eid && this.eid != '0') {
                            urls = "/admin/health/update"
                        } else {
                            urls = "/admin/health/save"
                        }
                        axios.post(urls, {
                                id: that.eid,
                                health_category_id: that.ruleForm.lb_value,
                                name: that.ruleForm.lb_title,
                                content: that.ruleForm.lb_content,
                                sort: that.ruleForm.lb_sort,
                                cover_map: that.mapListed,
                                file: that.fileListed,
                                to_show: that.ruleForm.lb_put,
                                show_time: time,
                                author: this.user.id,
                                type: '3',
                                keyword: this.ruleForm.keyword,
                                statement: that.ruleForm.lb_state,
                                create_user: that.ruleForm.ry_value,
                                base_browse: this.ruleForm.lb_ll,
                                base_praise: this.ruleForm.lb_dz,
                                base_collection: this.ruleForm.lb_sc
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = true
                            })
                    } else {
                        this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            // 编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                that.dialogVisible = true
                that.eid = row.id
                axios
                    .post("/admin/health/read", {
                        id: that.eid,
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        that.ruleForm.lb_value = data.health_category_id
                        that.ruleForm.lb_title = data.name
                        that.ruleForm.keyword = data.keyword
                        that.ruleForm.lb_content = data.content
                        that.ruleForm.lb_mapList = data.cover_map
                        that.mapListed = data.cover_map
                        that.ruleForm.lb_fileList = data.file
                        that.fileListed = data.file
                        that.ruleForm.lb_put = data.to_show ? data.to_show.toString() : ''
                        if (data.to_show == '2') {
                            that.ruleForm.lb_dstime = data.show_time
                        }
                        that.ruleForm.lb_sort = data.sort
                        that.ruleForm.lb_state = data.statement,
                            that.ruleForm.ry_value = data.create_user ? data.create_user : ''
                        that.ruleForm.lb_ll = data.base_browse
                        that.ruleForm.lb_dz = data.base_praise
                        that.ruleForm.lb_sc = data.base_collection
                    })
                    .catch(error => {})
            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/health/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            gettimes() {
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                let hour = nowDate.getHours(); //获取系统时，
                let min = nowDate.getMinutes(); //分
                let sec = nowDate.getSeconds(); //秒
                month = month > 9 ? month : '0' + month
                day = day > 9 ? day : '0' + day
                hour = hour > 9 ? hour : '0' + hour
                min = min > 9 ? min : '0' + min
                sec = sec > 9 ? sec : '0' + sec
                return `${year}-${month}-${day} ${hour}:${min}`;
            },
            // 类别
            getlbxx() {
                let that = this
                axios
                    .post("/admin/healthCategory/categoryHead", {
                        noChild:1
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.lb_options = response.data.data
                    })
                    .catch(error => {})
            },
            // 声明
            getstate() {
                let that = this
                axios
                    .post("/admin/getContentBySysTypeId", {
                        sys_id: 1,
                        type_id: 22
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.state_options = response.data.data
                    })
                    .catch(error => {})
            },
            goprev(item) {
                let that = this
                that.dialog_prev = true
                that.urls = item.url
            },
            // 
            uploadPrev(file) {
                let that = this
                that.dialog_video = true
                if (file.url) {
                    window.open(file.url)
                }
            },
            // 上传封面
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.mapListed = []
                that.mapListed.push(response.data)
            },
            //上传文件
            uploadSuccessed(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.uploads;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.fileListed = []
                that.fileListed.push(response.data)
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
            },
        },

    };
</script>


<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>